import React from 'react'
import Rent1 from '../../../assets/images/front/rent/1.jpg'
import Rent2 from '../../../assets/images/front/rent/2.jpg'
import Rent3 from '../../../assets/images/front/rent/3.jpg'
import Rent4 from '../../../assets/images/front/rent/4.jpg'
import Rent5 from '../../../assets/images/front/rent/5.jpg'
import Rent6 from '../../../assets/images/front/rent/6.jpg'
import Rent7 from '../../../assets/images/front/rent/7.jpg'
import Rent8 from '../../../assets/images/front/rent/8.jpg'
import Rent9 from '../../../assets/images/front/rent/9.jpg'
import Rent10 from '../../../assets/images/front/rent/10.jpg'
import Rent11 from '../../../assets/images/front/rent/11.jpg'
import Rent12 from '../../../assets/images/front/rent/12.jpg'

const Rent: React.FC = () => {
  return (
    <>
      <div className="container font-myriad md:px-4 pt-8 mt-[52px] lg:mt-[84px]">
        <div className="text-center">
          <h1>Pronájem prostor</h1>
          <h2>
            Příjemný a světlý prostor pro školení, meetingy, přednášky, tvorbu videí nebo třeba
            dětskou oslavu v centru Prahy.
          </h2>
          <p>
            Hledáte vhodné místo pro Vaší akci za rozumnou cenu? Klidná lokalita v centru Prahy,
            výborná dostupnost a bezproblémové parkování. K dispozici toaleta, kuchyňka s kávovarem,
            rychlovarnou konvicí, lednicí a mikrovlnnou troubou.
          </p>
          <p>
            Občerstvení si můžete přinést vlastní, nebo Vám rádi připravíme nějakou dobrotu dle naší
            nabídky. Prostor Vám připravíme dle Vaší potřeby, využít můžete velikou magnetickou
            tabuli, dataprojektor s plátnem, nebo využít naše studio na natáčení a focení. V případě
            zájmu nás kontaktujte na <a href="mailto:info@dohlavy.cz">info@dohlavy.cz</a>
          </p>
        </div>
        <div className="grid grid-cols-12 gap-4 pt-12">
          <div className="col-span-6 lg:col-span-3 flex">
            <img src={Rent1} alt="" className="w-100 h-100 block object-cover" />
          </div>
          <div className="col-span-6 lg:col-span-3 flex">
            <img src={Rent2} alt="" className="w-100 h-100 block object-cover" />
          </div>
          <div className="col-span-6 lg:col-span-3 flex">
            <img src={Rent3} alt="" className="w-100 h-100 block object-cover" />
          </div>
          <div className="col-span-6 lg:col-span-3 flex">
            <img src={Rent4} alt="" className="w-100 h-100 block object-cover" />
          </div>
          <div className="col-span-6 lg:col-span-3 flex">
            <img src={Rent5} alt="" className="w-100 h-100 block object-cover" />
          </div>
          <div className="col-span-6 lg:col-span-3 flex">
            <img src={Rent6} alt="" className="w-100 h-100 block object-cover" />
          </div>
          <div className="col-span-6 lg:col-span-3 flex">
            <img src={Rent7} alt="" className="w-100 h-100 block object-cover" />
          </div>
          <div className="col-span-6 lg:col-span-3 flex">
            <img src={Rent8} alt="" className="w-100 h-100 block object-cover" />
          </div>
          <div className="col-span-6 lg:col-span-3 flex">
            <img src={Rent9} alt="" className="w-100 h-100 block object-cover" />
          </div>
          <div className="col-span-6 lg:col-span-3 flex">
            <img src={Rent10} alt="" className="w-100 h-100 block object-cover" />
          </div>
          <div className="col-span-6 lg:col-span-3 flex">
            <img src={Rent11} alt="" className="w-100 h-100 block object-cover" />
          </div>
          <div className="col-span-6 lg:col-span-3 flex">
            <img src={Rent12} alt="" className="w-100 h-100 block object-cover" />
          </div>
        </div>
      </div>
    </>
  )
}

export default Rent
